module.exports = __webpack_public_path__ + "img/13.f6a3c93f.png";